module.exports = __webpack_public_path__ + "SX.png?a959e40872729a592d1d0a8899e86eff";